import AreaChartComponent from "../../components/Dashboard/charts/AreaChartComponent";
import BarChartComponent from "../../components/Dashboard/charts/BarChartComponent";
import LineChartComponent from "../../components/Dashboard/charts/LineChartComponent";
import PieChartComponent from "../../components/Dashboard/charts/PieChartComponent";
import TableComponent from "../../components/Dashboard/charts/TableComponent";
import ValueComponent from "../../components/Dashboard/charts/ValueComponent";
import { DashboardComponentChartProps, DashboardComponentKind } from "../../types/dashboards/dashboardComponent.type";

export const dashboardKind: Record<DashboardComponentKind, string> = {
  [DashboardComponentKind.BarChart]: 'Gráfico de barra',
  [DashboardComponentKind.PieChart]: 'Gráfico de pizza',
  [DashboardComponentKind.AreaChart]: 'Gráfico de área',
  [DashboardComponentKind.LineChart]: 'Gráfico de linha',
  [DashboardComponentKind.Value]: 'Valor',
  [DashboardComponentKind.Table]: 'Tabela',
}

export const dashboardChartComponent: Record<DashboardComponentKind, (props: DashboardComponentChartProps) => JSX.Element> = {
  [DashboardComponentKind.BarChart]: BarChartComponent,
  [DashboardComponentKind.PieChart]: PieChartComponent,
  [DashboardComponentKind.AreaChart]: AreaChartComponent,
  [DashboardComponentKind.LineChart]: LineChartComponent,
  [DashboardComponentKind.Value]: ValueComponent,
  [DashboardComponentKind.Table]: TableComponent,
}
